package pl.finn.forms

object CommonData {

  val listOfTaxOffices = listOf(
    "0202" to "0202 URZĄD SKARBOWY W BOLESŁAWCU ",
    "0203" to "0203 URZĄD SKARBOWY W BYSTRZYCY KŁODZKIEJ ",
    "0204" to "0204 URZĄD SKARBOWY W DZIERŻONIOWIE ",
    "0205" to "0205 URZĄD SKARBOWY W GŁOGOWIE ",
    "0206" to "0206 URZĄD SKARBOWY W JAWORZE ",
    "0207" to "0207 URZĄD SKARBOWY W JELENIEJ GÓRZE ",
    "0208" to "0208 URZĄD SKARBOWY W KAMIENNEJ GÓRZE ",
    "0209" to "0209 URZĄD SKARBOWY W KŁODZKU ",
    "0210" to "0210 URZĄD SKARBOWY W LEGNICY ",
    "0211" to "0211 URZĄD SKARBOWY W LUBANIU ",
    "0212" to "0212 URZĄD SKARBOWY W LUBINIE ",
    "0213" to "0213 URZĄD SKARBOWY W LWÓWKU ŚLĄSKIM ",
    "0214" to "0214 URZĄD SKARBOWY W MILICZU ",
    "0215" to "0215 URZĄD SKARBOWY W NOWEJ RUDZIE ",
    "0216" to "0216 URZĄD SKARBOWY W OLEŚNICY ",
    "0217" to "0217 URZĄD SKARBOWY W OŁAWIE ",
    "0218" to "0218 URZĄD SKARBOWY W STRZELINIE ",
    "0219" to "0219 URZĄD SKARBOWY W ŚRODZIE ŚLĄSKIEJ ",
    "0220" to "0220 URZĄD SKARBOWY W ŚWIDNICY ",
    "0221" to "0221 URZĄD SKARBOWY W TRZEBNICY ",
    "0222" to "0222 URZĄD SKARBOWY W WAŁBRZYCHU ",
    "0223" to "0223 URZĄD SKARBOWY W WOŁOWIE ",
    "0224" to "0224 URZĄD SKARBOWY WROCŁAW-FABRYCZNA ",
    "0225" to "0225 URZĄD SKARBOWY WROCŁAW-KRZYKI ",
    "0226" to "0226 URZĄD SKARBOWY WROCŁAW-PSIE POLE ",
    "0227" to "0227 URZĄD SKARBOWY WROCŁAW-STARE MIASTO ",
    "0228" to "0228 URZĄD SKARBOWY WROCŁAW-ŚRÓDMIEŚCIE ",
    "0229" to "0229 PIERWSZY URZĄD SKARBOWY WE WROCŁAWIU ",
    "0230" to "0230 URZĄD SKARBOWY W ZĄBKOWICACH ŚLĄSKICH ",
    "0231" to "0231 URZĄD SKARBOWY W ZGORZELCU ",
    "0232" to "0232 URZĄD SKARBOWY W ZŁOTORYI ",
    "0233" to "0233 URZĄD SKARBOWY W GÓRZE ",
    "0234" to "0234 URZĄD SKARBOWY W POLKOWICACH ",
    "0271" to "0271 DOLNOŚLĄSKI URZĄD SKARBOWY WE WROCŁAWIU ",
    "0402" to "0402 URZĄD SKARBOWY W ALEKSANDROWIE KUJAWSKIM ",
    "0403" to "0403 URZĄD SKARBOWY W BRODNICY ",
    "0404" to "0404 PIERWSZY URZĄD SKARBOWY W BYDGOSZCZY ",
    "0405" to "0405 DRUGI URZĄD SKARBOWY W BYDGOSZCZY ",
    "0406" to "0406 TRZECI URZĄD SKARBOWY W BYDGOSZCZY ",
    "0407" to "0407 URZĄD SKARBOWY W CHEŁMNIE ",
    "0408" to "0408 URZĄD SKARBOWY W GRUDZIĄDZU ",
    "0409" to "0409 URZĄD SKARBOWY W INOWROCŁAWIU ",
    "0410" to "0410 URZĄD SKARBOWY W LIPNIE ",
    "0411" to "0411 URZĄD SKARBOWY W MOGILNIE ",
    "0412" to "0412 URZĄD SKARBOWY W NAKLE NAD NOTECIĄ ",
    "0413" to "0413 URZĄD SKARBOWY W RADZIEJOWIE ",
    "0414" to "0414 URZĄD SKARBOWY W RYPINIE ",
    "0415" to "0415 URZĄD SKARBOWY W ŚWIECIU ",
    "0416" to "0416 PIERWSZY URZĄD SKARBOWY W TORUNIU ",
    "0417" to "0417 DRUGI URZĄD SKARBOWY W TORUNIU ",
    "0418" to "0418 URZĄD SKARBOWY W TUCHOLI ",
    "0419" to "0419 URZĄD SKARBOWY W WĄBRZEŹNIE ",
    "0420" to "0420 URZĄD SKARBOWY WE WŁOCŁAWKU ",
    "0421" to "0421 URZĄD SKARBOWY W ŻNINIE ",
    "0422" to "0422 URZĄD SKARBOWY W GOLUBIU-DOBRZYNIU ",
    "0423" to "0423 URZĄD SKARBOWY W SĘPÓLNIE KRAJEŃSKIM ",
    "0471" to "0471 KUJAWSKO-POMORSKI URZĄD SKARBOWY W BYDGOSZCZY ",
    "0602" to "0602 URZĄD SKARBOWY W BIAŁEJ PODLASKIEJ ",
    "0603" to "0603 URZĄD SKARBOWY W BIŁGORAJU ",
    "0604" to "0604 URZĄD SKARBOWY W CHEŁMIE ",
    "0605" to "0605 URZĄD SKARBOWY W HRUBIESZOWIE ",
    "0606" to "0606 URZĄD SKARBOWY W JANOWIE LUBELSKIM ",
    "0607" to "0607 URZĄD SKARBOWY W KRASNYMSTAWIE ",
    "0608" to "0608 URZĄD SKARBOWY W KRAŚNIKU ",
    "0609" to "0609 URZĄD SKARBOWY W LUBARTOWIE ",
    "0610" to "0610 PIERWSZY URZĄD SKARBOWY W LUBLINIE ",
    "0611" to "0611 DRUGI URZĄD SKARBOWY W LUBLINIE ",
    "0612" to "0612 TRZECI URZĄD SKARBOWY W LUBLINIE ",
    "0613" to "0613 URZĄD SKARBOWY W ŁUKOWIE ",
    "0614" to "0614 URZĄD SKARBOWY W OPOLU LUBELSKIM ",
    "0615" to "0615 URZĄD SKARBOWY W PARCZEWIE ",
    "0616" to "0616 URZĄD SKARBOWY W PUŁAWACH ",
    "0617" to "0617 URZĄD SKARBOWY W RADZYNIU PODLASKIM ",
    "0618" to "0618 URZĄD SKARBOWY W TOMASZOWIE LUBELSKIM ",
    "0619" to "0619 URZĄD SKARBOWY WE WŁODAWIE ",
    "0620" to "0620 URZĄD SKARBOWY W ZAMOŚCIU ",
    "0621" to "0621 URZĄD SKARBOWY W ŁĘCZNEJ ",
    "0622" to "0622 URZĄD SKARBOWY W RYKACH ",
    "0671" to "0671 LUBELSKI URZĄD SKARBOWY W LUBLINIE ",
    "0802" to "0802 URZĄD SKARBOWY W GORZOWIE WIELKOPOLSKIM ",
    "0803" to "0803 URZĄD SKARBOWY W KROŚNIE ODRZAŃSKIM ",
    "0804" to "0804 URZĄD SKARBOWY W MIĘDZYRZECZU ",
    "0805" to "0805 URZĄD SKARBOWY W NOWEJ SOLI ",
    "0806" to "0806 URZĄD SKARBOWY W SŁUBICACH ",
    "0807" to "0807 URZĄD SKARBOWY W ŚWIEBODZINIE ",
    "0808" to "0808 PIERWSZY URZĄD SKARBOWY W ZIELONEJ GÓRZE ",
    "0809" to "0809 DRUGI URZĄD SKARBOWY W ZIELONEJ GÓRZE ",
    "0810" to "0810 URZĄD SKARBOWY W ŻAGANIU ",
    "0811" to "0811 URZĄD SKARBOWY W ŻARACH ",
    "0812" to "0812 URZĄD SKARBOWY W DREZDENKU ",
    "0813" to "0813 URZĄD SKARBOWY W SULĘCINIE ",
    "0814" to "0814 URZĄD SKARBOWY WE WSCHOWIE ",
    "0871" to "0871 LUBUSKI URZĄD SKARBOWY W ZIELONEJ GÓRZE ",
    "1002" to "1002 URZĄD SKARBOWY W BEŁCHATOWIE ",
    "1003" to "1003 URZĄD SKARBOWY W BRZEZINACH ",
    "1004" to "1004 URZĄD SKARBOWY W GŁOWNIE ",
    "1005" to "1005 URZĄD SKARBOWY W KUTNIE ",
    "1006" to "1006 URZĄD SKARBOWY W ŁASKU ",
    "1007" to "1007 URZĄD SKARBOWY W ŁOWICZU ",
    "1008" to "1008 PIERWSZY URZĄD SKARBOWY ŁÓDŹ-BAŁUTY ",
    "1009" to "1009 DRUGI URZĄD SKARBOWY ŁÓDŹ-BAŁUTY ",
    "1010" to "1010 PIERWSZY URZĄD SKARBOWY ŁÓDŹ-GÓRNA ",
    "1011" to "1011 DRUGI URZĄD SKARBOWY ŁÓDŹ-GÓRNA ",
    "1012" to "1012 URZĄD SKARBOWY ŁÓDŹ-POLESIE ",
    "1013" to "1013 URZĄD SKARBOWY ŁÓDŹ-ŚRÓDMIEŚCIE ",
    "1014" to "1014 URZĄD SKARBOWY ŁÓDŹ-WIDZEW ",
    "1015" to "1015 URZĄD SKARBOWY W OPOCZNIE ",
    "1016" to "1016 URZĄD SKARBOWY W PABIANICACH ",
    "1017" to "1017 URZĄD SKARBOWY W PIOTRKOWIE TRYBUNALSKIM ",
    "1018" to "1018 URZĄD SKARBOWY W PODDĘBICACH ",
    "1019" to "1019 URZĄD SKARBOWY W RADOMSKU ",
    "1020" to "1020 URZĄD SKARBOWY W RAWIE MAZOWIECKIEJ ",
    "1021" to "1021 URZĄD SKARBOWY W SIERADZU ",
    "1022" to "1022 URZĄD SKARBOWY W SKIERNIEWICACH ",
    "1023" to "1023 URZĄD SKARBOWY W TOMASZOWIE MAZOWIECKIM ",
    "1024" to "1024 URZĄD SKARBOWY W WIELUNIU ",
    "1025" to "1025 URZĄD SKARBOWY W ZDUŃSKIEJ WOLI ",
    "1026" to "1026 URZĄD SKARBOWY W ZGIERZU ",
    "1027" to "1027 URZĄD SKARBOWY W WIERUSZOWIE ",
    "1028" to "1028 URZĄD SKARBOWY W ŁĘCZYCY ",
    "1029" to "1029 URZĄD SKARBOWY W PAJĘCZNIE ",
    "1071" to "1071 ŁÓDZKI URZĄD SKARBOWY W ŁODZI ",
    "1202" to "1202 URZĄD SKARBOWY W BOCHNI ",
    "1203" to "1203 URZĄD SKARBOWY W BRZESKU ",
    "1204" to "1204 URZĄD SKARBOWY W CHRZANOWIE ",
    "1205" to "1205 URZĄD SKARBOWY W DĄBROWIE TARNOWSKIEJ ",
    "1206" to "1206 URZĄD SKARBOWY W GORLICACH ",
    "1207" to "1207 PIERWSZY URZĄD SKARBOWY KRAKÓW ",
    "1208" to "1208 URZĄD SKARBOWY KRAKÓW-KROWODRZA ",
    "1209" to "1209 URZĄD SKARBOWY KRAKÓW-NOWA HUTA ",
    "1210" to "1210 URZĄD SKARBOWY KRAKÓW-PODGÓRZE ",
    "1211" to "1211 URZĄD SKARBOWY KRAKÓW-PRĄDNIK ",
    "1212" to "1212 URZĄD SKARBOWY KRAKÓW-STARE MIASTO ",
    "1213" to "1213 URZĄD SKARBOWY KRAKÓW-ŚRÓDMIEŚCIE ",
    "1214" to "1214 URZĄD SKARBOWY W LIMANOWEJ ",
    "1215" to "1215 URZĄD SKARBOWY W MIECHOWIE ",
    "1216" to "1216 URZĄD SKARBOWY W MYŚLENICACH ",
    "1217" to "1217 URZĄD SKARBOWY W NOWYM SĄCZU ",
    "1218" to "1218 URZĄD SKARBOWY W NOWYM TARGU ",
    "1219" to "1219 URZĄD SKARBOWY W OLKUSZU ",
    "1220" to "1220 URZĄD SKARBOWY W OŚWIĘCIMIU ",
    "1221" to "1221 URZĄD SKARBOWY W PROSZOWICACH ",
    "1222" to "1222 URZĄD SKARBOWY W SUCHEJ BESKIDZKIEJ ",
    "1223" to "1223 PIERWSZY URZĄD SKARBOWY W TARNOWIE ",
    "1224" to "1224 DRUGI URZĄD SKARBOWY W TARNOWIE ",
    "1225" to "1225 URZĄD SKARBOWY W WADOWICACH ",
    "1226" to "1226 URZĄD SKARBOWY W WIELICZCE ",
    "1227" to "1227 URZĄD SKARBOWY W ZAKOPANEM ",
    "1228" to "1228 DRUGI URZĄD SKARBOWY KRAKÓW ",
    "1271" to "1271 MAŁOPOLSKI URZĄD SKARBOWY W KRAKOWIE ",
    "1402" to "1402 URZĄD SKARBOWY W BIAŁOBRZEGACH ",
    "1403" to "1403 URZĄD SKARBOWY W CIECHANOWIE ",
    "1404" to "1404 URZĄD SKARBOWY W GARWOLINIE ",
    "1405" to "1405 URZĄD SKARBOWY W GOSTYNINIE ",
    "1406" to "1406 URZĄD SKARBOWY W GRODZISKU MAZOWIECKIM ",
    "1407" to "1407 URZĄD SKARBOWY W GRÓJCU ",
    "1408" to "1408 URZĄD SKARBOWY W KOZIENICACH ",
    "1409" to "1409 URZĄD SKARBOWY W LEGIONOWIE ",
    "1410" to "1410 URZĄD SKARBOWY W ŁOSICACH ",
    "1411" to "1411 URZĄD SKARBOWY W MAKOWIE MAZOWIECKIM ",
    "1412" to "1412 URZĄD SKARBOWY W MIŃSKU MAZOWIECKIM ",
    "1413" to "1413 URZĄD SKARBOWY W MŁAWIE ",
    "1414" to "1414 URZĄD SKARBOWY W NOWYM DWORZE MAZOWIECKIM ",
    "1415" to "1415 URZĄD SKARBOWY W OSTROŁĘCE ",
    "1416" to "1416 URZĄD SKARBOWY W OSTROWI MAZOWIECKIEJ ",
    "1417" to "1417 URZĄD SKARBOWY W OTWOCKU ",
    "1418" to "1418 URZĄD SKARBOWY W PIASECZNIE ",
    "1419" to "1419 URZĄD SKARBOWY W PŁOCKU ",
    "1420" to "1420 URZĄD SKARBOWY W PŁOŃSKU ",
    "1421" to "1421 URZĄD SKARBOWY W PRUSZKOWIE ",
    "1422" to "1422 URZĄD SKARBOWY W PRZASNYSZU ",
    "1423" to "1423 URZĄD SKARBOWY W PUŁTUSKU ",
    "1424" to "1424 PIERWSZY URZĄD SKARBOWY W RADOMIU ",
    "1425" to "1425 DRUGI URZĄD SKARBOWY W RADOMIU ",
    "1426" to "1426 URZĄD SKARBOWY W SIEDLCACH ",
    "1427" to "1427 URZĄD SKARBOWY W SIERPCU ",
    "1428" to "1428 URZĄD SKARBOWY W SOCHACZEWIE ",
    "1429" to "1429 URZĄD SKARBOWY W SOKOŁOWIE PODLASKIM ",
    "1430" to "1430 URZĄD SKARBOWY W SZYDŁOWCU ",
    "1431" to "1431 URZĄD SKARBOWY WARSZAWA-BEMOWO ",
    "1432" to "1432 URZĄD SKARBOWY WARSZAWA-BIELANY ",
    "1433" to "1433 URZĄD SKARBOWY WARSZAWA-MOKOTÓW ",
    "1434" to "1434 URZĄD SKARBOWY WARSZAWA-PRAGA ",
    "1435" to "1435 PIERWSZY URZĄD SKARBOWY WARSZAWA-ŚRÓDMIEŚCIE ",
    "1436" to "1436 DRUGI URZĄD SKARBOWY WARSZAWA-ŚRÓDMIEŚCIE ",
    "1437" to "1437 URZĄD SKARBOWY WARSZAWA-TARGÓWEK ",
    "1438" to "1438 URZĄD SKARBOWY WARSZAWA-URSYNÓW ",
    "1439" to "1439 URZĄD SKARBOWY WARSZAWA-WAWER ",
    "1440" to "1440 URZĄD SKARBOWY WARSZAWA-WOLA ",
    "1441" to "1441 URZĄD SKARBOWY W WĘGROWIE ",
    "1442" to "1442 URZĄD SKARBOWY W WOŁOMINIE ",
    "1443" to "1443 URZĄD SKARBOWY W WYSZKOWIE ",
    "1444" to "1444 URZĄD SKARBOWY W ZWOLENIU ",
    "1445" to "1445 URZĄD SKARBOWY W ŻUROMINIE ",
    "1446" to "1446 URZĄD SKARBOWY W ŻYRARDOWIE ",
    "1447" to "1447 URZĄD SKARBOWY W LIPSKU ",
    "1448" to "1448 URZĄD SKARBOWY W PRZYSUSZE ",
    "1449" to "1449 TRZECI URZĄD SKARBOWY WARSZAWA-ŚRÓDMIEŚCIE ",
    "1471" to "1471 PIERWSZY MAZOWIECKI URZĄD SKARBOWY W WARSZAWIE ",
    "1472" to "1472 DRUGI MAZOWIECKI URZĄD SKARBOWY W WARSZAWIE ",
    "1473" to "1473 TRZECI MAZOWIECKI URZĄD SKARBOWY W RADOMIU ",
    "1602" to "1602 URZĄD SKARBOWY W BRZEGU ",
    "1603" to "1603 URZĄD SKARBOWY W GŁUBCZYCACH ",
    "1604" to "1604 URZĄD SKARBOWY W KĘDZIERZYNIE-KOŹLU ",
    "1605" to "1605 URZĄD SKARBOWY W KLUCZBORKU ",
    "1606" to "1606 URZĄD SKARBOWY W NAMYSŁOWIE ",
    "1607" to "1607 URZĄD SKARBOWY W NYSIE ",
    "1608" to "1608 URZĄD SKARBOWY W OLEŚNIE ",
    "1609" to "1609 PIERWSZY URZĄD SKARBOWY W OPOLU ",
    "1610" to "1610 DRUGI URZĄD SKARBOWY W OPOLU ",
    "1611" to "1611 URZĄD SKARBOWY W PRUDNIKU ",
    "1612" to "1612 URZĄD SKARBOWY W STRZELCACH OPOLSKICH ",
    "1613" to "1613 URZĄD SKARBOWY W KRAPKOWICACH ",
    "1671" to "1671 OPOLSKI URZĄD SKARBOWY W OPOLU ",
    "1802" to "1802 URZĄD SKARBOWY W BRZOZOWIE ",
    "1803" to "1803 URZĄD SKARBOWY W DĘBICY ",
    "1804" to "1804 URZĄD SKARBOWY W JAROSŁAWIU ",
    "1805" to "1805 URZĄD SKARBOWY W JAŚLE ",
    "1806" to "1806 URZĄD SKARBOWY W KOLBUSZOWEJ ",
    "1807" to "1807 URZĄD SKARBOWY W KROŚNIE ",
    "1808" to "1808 URZĄD SKARBOWY W LESKU ",
    "1809" to "1809 URZĄD SKARBOWY W LEŻAJSKU ",
    "1810" to "1810 URZĄD SKARBOWY W LUBACZOWIE ",
    "1811" to "1811 URZĄD SKARBOWY W ŁAŃCUCIE ",
    "1812" to "1812 URZĄD SKARBOWY W MIELCU ",
    "1813" to "1813 URZĄD SKARBOWY W PRZEMYŚLU ",
    "1814" to "1814 URZĄD SKARBOWY W PRZEWORSKU ",
    "1815" to "1815 URZĄD SKARBOWY W ROPCZYCACH ",
    "1816" to "1816 PIERWSZY URZĄD SKARBOWY W RZESZOWIE ",
    "1817" to "1817 URZĄD SKARBOWY W SANOKU ",
    "1818" to "1818 URZĄD SKARBOWY W STALOWEJ WOLI ",
    "1819" to "1819 URZĄD SKARBOWY W STRZYŻOWIE ",
    "1820" to "1820 URZĄD SKARBOWY W TARNOBRZEGU ",
    "1821" to "1821 URZĄD SKARBOWY W USTRZYKACH DOLNYCH ",
    "1822" to "1822 DRUGI URZĄD SKARBOWY W RZESZOWIE ",
    "1823" to "1823 URZĄD SKARBOWY W NISKU ",
    "1871" to "1871 PODKARPACKI URZĄD SKARBOWY W RZESZOWIE ",
    "2002" to "2002 URZĄD SKARBOWY W AUGUSTOWIE ",
    "2003" to "2003 PIERWSZY URZĄD SKARBOWY W BIAŁYMSTOKU ",
    "2004" to "2004 DRUGI URZĄD SKARBOWY W BIAŁYMSTOKU ",
    "2005" to "2005 URZĄD SKARBOWY W BIELSKU PODLASKIM ",
    "2006" to "2006 URZĄD SKARBOWY W GRAJEWIE ",
    "2007" to "2007 URZĄD SKARBOWY W KOLNIE ",
    "2008" to "2008 URZĄD SKARBOWY W ŁOMŻY ",
    "2009" to "2009 URZĄD SKARBOWY W MOŃKACH ",
    "2010" to "2010 URZĄD SKARBOWY W SIEMIATYCZACH ",
    "2011" to "2011 URZĄD SKARBOWY W SOKÓŁCE ",
    "2012" to "2012 URZĄD SKARBOWY W SUWAŁKACH ",
    "2013" to "2013 URZĄD SKARBOWY W WYSOKIEM MAZOWIECKIEM ",
    "2014" to "2014 URZĄD SKARBOWY W ZAMBROWIE ",
    "2015" to "2015 URZĄD SKARBOWY W HAJNÓWCE ",
    "2071" to "2071 PODLASKI URZĄD SKARBOWY W BIAŁYMSTOKU ",
    "2202" to "2202 URZĄD SKARBOWY W BYTOWIE ",
    "2203" to "2203 URZĄD SKARBOWY W CHOJNICACH ",
    "2204" to "2204 URZĄD SKARBOWY W CZŁUCHOWIE ",
    "2205" to "2205 PIERWSZY URZĄD SKARBOWY W GDAŃSKU ",
    "2206" to "2206 DRUGI URZĄD SKARBOWY W GDAŃSKU ",
    "2207" to "2207 TRZECI URZĄD SKARBOWY W GDAŃSKU ",
    "2208" to "2208 PIERWSZY URZĄD SKARBOWY W GDYNI ",
    "2209" to "2209 DRUGI URZĄD SKARBOWY W GDYNI ",
    "2210" to "2210 URZĄD SKARBOWY W KARTUZACH ",
    "2211" to "2211 URZĄD SKARBOWY W KOŚCIERZYNIE ",
    "2212" to "2212 URZĄD SKARBOWY W KWIDZYNIE ",
    "2213" to "2213 URZĄD SKARBOWY W LĘBORKU ",
    "2214" to "2214 URZĄD SKARBOWY W MALBORKU ",
    "2215" to "2215 URZĄD SKARBOWY W PUCKU ",
    "2216" to "2216 URZĄD SKARBOWY W SŁUPSKU ",
    "2217" to "2217 URZĄD SKARBOWY W SOPOCIE ",
    "2218" to "2218 URZĄD SKARBOWY W STAROGARDZIE GDAŃSKIM ",
    "2219" to "2219 URZĄD SKARBOWY W TCZEWIE ",
    "2220" to "2220 URZĄD SKARBOWY W WEJHEROWIE ",
    "2221" to "2221 URZĄD SKARBOWY W PRUSZCZU GDAŃSKIM ",
    "2271" to "2271 POMORSKI URZĄD SKARBOWY W GDAŃSKU ",
    "2402" to "2402 URZĄD SKARBOWY W BĘDZINIE ",
    "2403" to "2403 PIERWSZY URZĄD SKARBOWY W BIELSKU-BIAŁEJ ",
    "2404" to "2404 DRUGI URZĄD SKARBOWY W BIELSKU-BIAŁEJ ",
    "2405" to "2405 URZĄD SKARBOWY W BYTOMIU ",
    "2406" to "2406 URZĄD SKARBOWY W CHORZOWIE ",
    "2407" to "2407 URZĄD SKARBOWY W CIESZYNIE ",
    "2408" to "2408 URZĄD SKARBOWY W CZECHOWICACH-DZIEDZICACH ",
    "2409" to "2409 PIERWSZY URZĄD SKARBOWY W CZĘSTOCHOWIE ",
    "2410" to "2410 DRUGI URZĄD SKARBOWY W CZĘSTOCHOWIE ",
    "2411" to "2411 URZĄD SKARBOWY W DĄBROWIE GÓRNICZEJ ",
    "2412" to "2412 PIERWSZY URZĄD SKARBOWY W GLIWICACH ",
    "2413" to "2413 DRUGI URZĄD SKARBOWY W GLIWICACH ",
    "2414" to "2414 URZĄD SKARBOWY W JASTRZĘBIU-ZDROJU ",
    "2415" to "2415 URZĄD SKARBOWY W JAWORZNIE ",
    "2416" to "2416 PIERWSZY URZĄD SKARBOWY W KATOWICACH ",
    "2417" to "2417 DRUGI URZĄD SKARBOWY W KATOWICACH ",
    "2418" to "2418 URZĄD SKARBOWY W KŁOBUCKU ",
    "2419" to "2419 URZĄD SKARBOWY W LUBLIŃCU ",
    "2420" to "2420 URZĄD SKARBOWY W MIKOŁOWIE ",
    "2421" to "2421 URZĄD SKARBOWY W MYSŁOWICACH ",
    "2422" to "2422 URZĄD SKARBOWY W MYSZKOWIE ",
    "2423" to "2423 URZĄD SKARBOWY W PIEKARACH ŚLĄSKICH ",
    "2424" to "2424 URZĄD SKARBOWY W PSZCZYNIE ",
    "2425" to "2425 URZĄD SKARBOWY W RACIBORZU ",
    "2426" to "2426 URZĄD SKARBOWY W RUDZIE ŚLĄSKIEJ ",
    "2427" to "2427 URZĄD SKARBOWY W RYBNIKU ",
    "2428" to "2428 URZĄD SKARBOWY W SIEMIANOWICACH ŚLĄSKICH ",
    "2429" to "2429 URZĄD SKARBOWY W SOSNOWCU ",
    "2430" to "2430 URZĄD SKARBOWY W TARNOWSKICH GÓRACH ",
    "2431" to "2431 URZĄD SKARBOWY W TYCHACH ",
    "2432" to "2432 URZĄD SKARBOWY W WODZISŁAWIU ŚLĄSKIM ",
    "2433" to "2433 URZĄD SKARBOWY W ZABRZU ",
    "2434" to "2434 URZĄD SKARBOWY W ZAWIERCIU ",
    "2435" to "2435 URZĄD SKARBOWY W ŻORACH ",
    "2436" to "2436 URZĄD SKARBOWY W ŻYWCU ",
    "2471" to "2471 PIERWSZY ŚLĄSKI URZĄD SKARBOWY W SOSNOWCU ",
    "2472" to "2472 DRUGI ŚLĄSKI URZĄD SKARBOWY W BIELSKU-BIAŁEJ ",
    "2602" to "2602 URZĄD SKARBOWY W BUSKU-ZDROJU ",
    "2603" to "2603 URZĄD SKARBOWY W JĘDRZEJOWIE ",
    "2604" to "2604 PIERWSZY URZĄD SKARBOWY W KIELCACH ",
    "2605" to "2605 DRUGI URZĄD SKARBOWY W KIELCACH ",
    "2606" to "2606 URZĄD SKARBOWY W KOŃSKICH ",
    "2607" to "2607 URZĄD SKARBOWY W OPATOWIE ",
    "2608" to "2608 URZĄD SKARBOWY W OSTROWCU ŚWIĘTOKRZYSKIM ",
    "2609" to "2609 URZĄD SKARBOWY W PIŃCZOWIE ",
    "2610" to "2610 URZĄD SKARBOWY W SANDOMIERZU ",
    "2611" to "2611 URZĄD SKARBOWY W SKARŻYSKU-KAMIENNEJ ",
    "2612" to "2612 URZĄD SKARBOWY W STARACHOWICACH ",
    "2613" to "2613 URZĄD SKARBOWY W STASZOWIE ",
    "2614" to "2614 URZĄD SKARBOWY W KAZIMIERZY WIELKIEJ ",
    "2615" to "2615 URZĄD SKARBOWY WE WŁOSZCZOWIE ",
    "2671" to "2671 ŚWIĘTOKRZYSKI URZĄD SKARBOWY W KIELCACH ",
    "2802" to "2802 URZĄD SKARBOWY W BARTOSZYCACH ",
    "2803" to "2803 URZĄD SKARBOWY W BRANIEWIE ",
    "2804" to "2804 URZĄD SKARBOWY W DZIAŁDOWIE ",
    "2805" to "2805 URZĄD SKARBOWY W ELBLĄGU ",
    "2806" to "2806 URZĄD SKARBOWY W EŁKU ",
    "2807" to "2807 URZĄD SKARBOWY W GIŻYCKU ",
    "2808" to "2808 URZĄD SKARBOWY W IŁAWIE ",
    "2809" to "2809 URZĄD SKARBOWY W KĘTRZYNIE ",
    "2810" to "2810 URZĄD SKARBOWY W NIDZICY ",
    "2811" to "2811 URZĄD SKARBOWY W NOWYM MIEŚCIE LUBAWSKIM ",
    "2812" to "2812 URZĄD SKARBOWY W OLECKU ",
    "2813" to "2813 URZĄD SKARBOWY W OLSZTYNIE ",
    "2814" to "2814 URZĄD SKARBOWY W OSTRÓDZIE ",
    "2815" to "2815 URZĄD SKARBOWY W PISZU ",
    "2816" to "2816 URZĄD SKARBOWY W SZCZYTNIE ",
    "2871" to "2871 WARMIŃSKO-MAZURSKI URZĄD SKARBOWY W OLSZTYNIE ",
    "3002" to "3002 URZĄD SKARBOWY W CZARNKOWIE ",
    "3003" to "3003 URZĄD SKARBOWY W GNIEŹNIE ",
    "3004" to "3004 URZĄD SKARBOWY W GOSTYNIU ",
    "3005" to "3005 URZĄD SKARBOWY W GRODZISKU WIELKOPOLSKIM ",
    "3006" to "3006 URZĄD SKARBOWY W JAROCINIE ",
    "3007" to "3007 PIERWSZY URZĄD SKARBOWY W KALISZU ",
    "3008" to "3008 DRUGI URZĄD SKARBOWY W KALISZU ",
    "3009" to "3009 URZĄD SKARBOWY W KĘPNIE ",
    "3010" to "3010 URZĄD SKARBOWY W KOLE ",
    "3011" to "3011 URZĄD SKARBOWY W KONINIE ",
    "3012" to "3012 URZĄD SKARBOWY W KOŚCIANIE ",
    "3013" to "3013 URZĄD SKARBOWY W KROTOSZYNIE ",
    "3014" to "3014 URZĄD SKARBOWY W LESZNIE ",
    "3015" to "3015 URZĄD SKARBOWY W MIĘDZYCHODZIE ",
    "3016" to "3016 URZĄD SKARBOWY W NOWYM TOMYŚLU ",
    "3017" to "3017 URZĄD SKARBOWY W OSTROWIE WIELKOPOLSKIM ",
    "3018" to "3018 URZĄD SKARBOWY W OSTRZESZOWIE ",
    "3019" to "3019 URZĄD SKARBOWY W PILE ",
    "3020" to "3020 URZĄD SKARBOWY POZNAŃ-GRUNWALD ",
    "3021" to "3021 URZĄD SKARBOWY POZNAŃ-JEŻYCE ",
    "3022" to "3022 URZĄD SKARBOWY POZNAŃ-NOWE MIASTO ",
    "3023" to "3023 PIERWSZY URZĄD SKARBOWY W POZNANIU ",
    "3025" to "3025 URZĄD SKARBOWY POZNAŃ-WINOGRADY ",
    "3026" to "3026 URZĄD SKARBOWY POZNAŃ-WILDA ",
    "3027" to "3027 URZĄD SKARBOWY W RAWICZU ",
    "3028" to "3028 URZĄD SKARBOWY W SŁUPCY ",
    "3029" to "3029 URZĄD SKARBOWY W SZAMOTUŁACH ",
    "3030" to "3030 URZĄD SKARBOWY W ŚREMIE ",
    "3031" to "3031 URZĄD SKARBOWY W ŚRODZIE WIELKOPOLSKIEJ ",
    "3032" to "3032 URZĄD SKARBOWY W TURKU ",
    "3033" to "3033 URZĄD SKARBOWY W WĄGROWCU ",
    "3034" to "3034 URZĄD SKARBOWY W WOLSZTYNIE ",
    "3035" to "3035 URZĄD SKARBOWY WE WRZEŚNI ",
    "3036" to "3036 URZĄD SKARBOWY W ZŁOTOWIE ",
    "3037" to "3037 URZĄD SKARBOWY W CHODZIEŻY ",
    "3038" to "3038 URZĄD SKARBOWY W OBORNIKACH ",
    "3039" to "3039 URZĄD SKARBOWY W PLESZEWIE ",
    "3071" to "3071 PIERWSZY WIELKOPOLSKI URZĄD SKARBOWY W POZNANIU ",
    "3072" to "3072 DRUGI WIELKOPOLSKI URZĄD SKARBOWY W KALISZU ",
    "3202" to "3202 URZĄD SKARBOWY W BIAŁOGARDZIE ",
    "3203" to "3203 URZĄD SKARBOWY W CHOSZCZNIE ",
    "3204" to "3204 URZĄD SKARBOWY W DRAWSKU POMORSKIM ",
    "3205" to "3205 URZĄD SKARBOWY W GOLENIOWIE ",
    "3206" to "3206 URZĄD SKARBOWY W GRYFICACH ",
    "3207" to "3207 URZĄD SKARBOWY W GRYFINIE ",
    "3208" to "3208 URZĄD SKARBOWY W KAMIENIU POMORSKIM ",
    "3209" to "3209 URZĄD SKARBOWY W KOŁOBRZEGU ",
    "3210" to "3210 PIERWSZY URZĄD SKARBOWY W KOSZALINIE ",
    "3211" to "3211 DRUGI URZĄD SKARBOWY W KOSZALINIE ",
    "3212" to "3212 URZĄD SKARBOWY W MYŚLIBORZU ",
    "3213" to "3213 URZĄD SKARBOWY W PYRZYCACH ",
    "3214" to "3214 URZĄD SKARBOWY W STARGARDZIE SZCZECIŃSKIM ",
    "3215" to "3215 PIERWSZY URZĄD SKARBOWY W SZCZECINIE ",
    "3216" to "3216 DRUGI URZĄD SKARBOWY W SZCZECINIE ",
    "3217" to "3217 TRZECI URZĄD SKARBOWY W SZCZECINIE ",
    "3218" to "3218 URZĄD SKARBOWY W SZCZECINKU ",
    "3219" to "3219 URZĄD SKARBOWY W ŚWINOUJŚCIU ",
    "3220" to "3220 URZĄD SKARBOWY W WAŁCZU ",
    "3271" to "3271 ZACHODNIOPOMORSKI URZĄD SKARBOWY W SZCZECINIE"
  )

  val countryCodeMap = mapOf(
    "AF" to "Afganistan-AF",
    "AL" to "Albania-AL",
    "DZ" to "Algieria-DZ",
    "AD" to "Andora-AD",
    "AO" to "Angola-AO",
    "AI" to "Anguilla-AI",
    "AQ" to "Antarktyda-AQ",
    "AG" to "Antigua i Barbuda-AG",
    "SA" to "Arabia Saudyjska-SA",
    "AR" to "Argentyna-AR",
    "AM" to "Armenia-AM",
    "AW" to "Aruba-AW",
    "AU" to "Australia-AU",
    "AT" to "Austria-AT",
    "AZ" to "Azerbejdżan-AZ",
    "BS" to "Bahamy-BS",
    "BH" to "Bahrajn-BH",
    "BD" to "Bangladesz-BD",
    "BB" to "Barbados-BB",
    "BE" to "Belgia-BE",
    "BZ" to "Belize-BZ",
    "BJ" to "Benin-BJ",
    "BM" to "Bermudy-BM",
    "BT" to "Bhutan-BT",
    "BY" to "Białoruś-BY",
    "MM" to "Birma-MM",
    "BO" to "Boliwia-BO",
    "BQ" to "Bonaire Sint Eustatius i Saba-BQ",
    "BA" to "Bośnia i Hercegowina-BA",
    "BW" to "Botswana-BW",
    "BR" to "Brazylia-BR",
    "BN" to "Brunei-BN",
    "IO" to "Brytyjskie Terytorium Oceanu Indyjskiego-IO",
    "VG" to "Brytyjskie Wyspy Dziewicze-VG",
    "BG" to "Bułgaria-BG",
    "BF" to "Burkina Faso-BF",
    "BI" to "Burundi-BI",
    "CL" to "Chile-CL",
    "CN" to "Chiny-CN",
    "HR" to "Chorwacja-HR",
    "CW" to "Curaçao-CW",
    "CY" to "Cypr-CY",
    "TD" to "Czad-TD",
    "ME" to "Czarnogóra-ME",
    "CZ" to "Czechy-CZ",
    "UM" to "Dalekie Wyspy Mniejsze Stanów Zjednoczonych-UM",
    "DK" to "Dania-DK",
    "CD" to "Demokratyczna Republika Konga-CD",
    "DM" to "Dominika-DM",
    "DO" to "Dominikana-DO",
    "DJ" to "Dżibuti-DJ",
    "EG" to "Egipt-EG",
    "EC" to "Ekwador-EC",
    "ER" to "Erytrea-ER",
    "EE" to "Estonia-EE",
    "ET" to "Etiopia-ET",
    "FK" to "Falklandy-FK",
    "FJ" to "Fidżi-FJ",
    "PH" to "Filipiny-PH",
    "FI" to "Finlandia-FI",
    "FR" to "Francja-FR",
    "TF" to "Francuskie Terytoria Południowe i Antarktyczne-TF",
    "GA" to "Gabon-GA",
    "GM" to "Gambia-GM",
    "GS" to "Georgia Południowa i Sandwich Południowy-GS",
    "GH" to "Ghana-GH",
    "GI" to "Gibraltar-GI",
    "GR" to "Grecja-GR",
    "GD" to "Grenada-GD",
    "GL" to "Grenlandia-GL",
    "GE" to "Gruzja-GE",
    "GU" to "Guam-GU",
    "GG" to "Guernsey-GG",
    "GF" to "Gujana Francuska-GF",
    "GY" to "Gujana-GY",
    "GP" to "Gwadelupa-GP",
    "GT" to "Gwatemala-GT",
    "GW" to "Gwinea Bissau-GW",
    "GQ" to "Gwinea Równikowa-GQ",
    "GN" to "Gwinea-GN",
    "HT" to "Haiti-HT",
    "ES" to "Hiszpania-ES",
    "NL" to "Holandia-NL",
    "HN" to "Honduras-HN",
    "HK" to "Hongkong-HK",
    "IN" to "Indie-IN",
    "ID" to "Indonezja-ID",
    "IQ" to "Irak-IQ",
    "IR" to "Iran-IR",
    "IE" to "Irlandia-IE",
    "IS" to "Islandia-IS",
    "IL" to "Izrael-IL",
    "JM" to "Jamajka-JM",
    "JP" to "Japonia-JP",
    "YE" to "Jemen-YE",
    "JE" to "Jersey-JE",
    "JO" to "Jordania-JO",
    "KY" to "Kajmany-KY",
    "KH" to "Kambodża-KH",
    "CM" to "Kamerun-CM",
    "CA" to "Kanada-CA",
    "QA" to "Katar-QA",
    "KZ" to "Kazachstan-KZ",
    "KE" to "Kenia-KE",
    "KG" to "Kirgistan-KG",
    "KI" to "Kiribati-KI",
    "CO" to "Kolumbia-CO",
    "KM" to "Komory-KM",
    "CG" to "Kongo-CG",
    "KR" to "Korea Południowa-KR",
    "KP" to "Korea Północna-KP",
    "CR" to "Kostaryka-CR",
    "CU" to "Kuba-CU",
    "KW" to "Kuwejt-KW",
    "LA" to "Laos-LA",
    "LS" to "Lesotho-LS",
    "LB" to "Liban-LB",
    "LR" to "Liberia-LR",
    "LY" to "Libia-LY",
    "LI" to "Liechtenstein-LI",
    "LT" to "Litwa-LT",
    "LU" to "Luksemburg-LU",
    "LV" to "Łotwa-LV",
    "MK" to "Macedonia-MK",
    "MG" to "Madagaskar-MG",
    "YT" to "Majotta-YT",
    "MO" to "Makau-MO",
    "MW" to "Malawi-MW",
    "MV" to "Malediwy-MV",
    "MY" to "Malezja-MY",
    "ML" to "Mali-ML",
    "MT" to "Malta-MT",
    "MP" to "Mariany Północne-MP",
    "MA" to "Maroko-MA",
    "MQ" to "Martynika-MQ",
    "MR" to "Mauretania-MR",
    "MU" to "Mauritius-MU",
    "MX" to "Meksyk-MX",
    "FM" to "Mikronezja-FM",
    "MD" to "Mołdawia-MD",
    "MC" to "Monako-MC",
    "MN" to "Mongolia-MN",
    "MS" to "Montserrat-MS",
    "MZ" to "Mozambik-MZ",
    "NA" to "Namibia-NA",
    "NR" to "Nauru-NR",
    "NP" to "Nepal-NP",
    "DE" to "Niemcy-DE",
    "NE" to "Niger-NE",
    "NG" to "Nigeria-NG",
    "NI" to "Nikaragua-NI",
    "NU" to "Niue-NU",
    "NF" to "Norfolk-NF",
    "NO" to "Norwegia-NO",
    "NC" to "Nowa Kaledonia-NC",
    "NZ" to "Nowa Zelandia-NZ",
    "OM" to "Oman-OM",
    "PK" to "Pakistan-PK",
    "PW" to "Palau-PW",
    "PS" to "Palestyna-PS",
    "PA" to "Panama-PA",
    "PG" to "Papua-Nowa Gwinea-PG",
    "PY" to "Paragwaj-PY",
    "PE" to "Peru-PE",
    "PN" to "Pitcairn-PN",
    "PF" to "Polinezja Francuska-PF",
    "PL" to "Polska-PL",
    "PR" to "Portoryko-PR",
    "PT" to "Portugalia-PT",
    "TW" to "Tajwan-TW",
    "ZA" to "Republika Południowej Afryki-ZA",
    "CF" to "Republika Środkowoafrykańska-CF",
    "CV" to "Republika Zielonego Przylądka-CV",
    "RE" to "Reunion-RE",
    "RU" to "Rosja-RU",
    "RO" to "Rumunia-RO",
    "RW" to "Rwanda-RW",
    "EH" to "Sahara Zachodnia-EH",
    "KN" to "Saint Kitts i Nevis-KN",
    "LC" to "Saint Lucia-LC",
    "VC" to "Saint Vincent i Grenadyny-VC",
    "BL" to "Saint-Barthélemy-BL",
    "MF" to "Saint-Martin-MF",
    "PM" to "Saint-Pierre i Miquelon-PM",
    "SV" to "Salwador-SV",
    "AS" to "Samoa Amerykańskie-AS",
    "WS" to "Samoa-WS",
    "SM" to "San Marino-SM",
    "SN" to "Senegal-SN",
    "RS" to "Serbia-RS",
    "SC" to "Seszele-SC",
    "SL" to "Sierra Leone-SL",
    "SG" to "Singapur-SG",
    "SX" to "Sint Maarten-SX",
    "SK" to "Słowacja-SK",
    "SI" to "Słowenia-SI",
    "SO" to "Somalia-SO",
    "LK" to "Sri Lanka-LK",
    "US" to "Stany Zjednoczone-US",
    "SZ" to "Suazi-SZ",
    "SD" to "Sudan-SD",
    "SR" to "Surinam-SR",
    "SJ" to "Svalbard i Jan Mayen-SJ",
    "SY" to "Syria-SY",
    "CH" to "Szwajcaria-CH",
    "SE" to "Szwecja-SE",
    "TJ" to "Tadżykistan-TJ",
    "TH" to "Tajlandia-TH",
    "TZ" to "Tanzania-TZ",
    "TL" to "Timor Wschodni-TL",
    "TG" to "Togo-TG",
    "TK" to "Tokelau-TK",
    "TO" to "Tonga-TO",
    "TT" to "Trynidad i Tobago-TT",
    "TN" to "Tunezja-TN",
    "TR" to "Turcja-TR",
    "TM" to "Turkmenistan-TM",
    "TC" to "Turks i Caicos-TC",
    "TV" to "Tuvalu-TV",
    "UG" to "Uganda-UG",
    "UA" to "Ukraina-UA",
    "UY" to "Urugwaj-UY",
    "UZ" to "Uzbekistan-UZ",
    "VU" to "Vanuatu-VU",
    "WF" to "Wallis i Futuna-WF",
    "VA" to "Watykan-VA",
    "VE" to "Wenezuela-VE",
    "HU" to "Węgry-HU",
    "GB" to "Wielka Brytania-GB",
    "VN" to "Wietnam-VN",
    "IT" to "Włochy-IT",
    "CI" to "Wybrzeże Kości Słoniowej-CI",
    "BV" to "Wyspa Bouveta-BV",
    "CX" to "Wyspa Bożego Narodzenia-CX",
    "IM" to "Wyspa Man-IM",
    "SH" to "Wyspa Świętej Heleny Wyspa Wniebowstąpienia i Tristan da Cunha-SH",
    "AX" to "Wyspy Alandzkie-AX",
    "CK" to "Wyspy Cooka-CK",
    "VI" to "Wyspy Dziewicze Stanów Zjednoczonych-VI",
    "HM" to "Wyspy Heard i McDonalda-HM",
    "CC" to "Wyspy Kokosowe-CC",
    "MH" to "Wyspy Marshalla-MH",
    "FO" to "Wyspy Owcze-FO",
    "SB" to "Wyspy Salomona-SB",
    "ST" to "Wyspy Świętego Tomasza i Książęca-ST",
    "ZM" to "Zambia-ZM",
    "ZW" to "Zimbabwe-ZW",
    "AE" to "Zjednoczone Emiraty Arabskie-AE"
  )

}